export default function useScrollControl() {
  const { y } = useWindowScroll()
  const { proxy } = useSmartsupp()
  const { locale } = useI18n()

  onMounted(() => {
    watch(
      y,
      (newY) => {
        if (locale.value !== 'cs') {
          proxy.smartsupp('chat:hide')
          return
        }

        if (window.innerHeight + newY >= document.body.offsetHeight - 50) {
          proxy.smartsupp('chat:hide')
        } else {
          proxy.smartsupp('chat:show')
        }
      },
      { immediate: true }
    )
  })
}
